// Components - Main Export

// Layout Components
export { Header } from './layout/Header.jsx';
export { Footer } from './layout/Footer.jsx';
export { Section, SectionHeader } from './layout/Section.jsx';
export { Container } from './layout/Container.jsx';
export { PageWrapper } from './layout/PageWrapper.jsx';
export { ScrollSnapContainer, ScrollSnapSection } from './layout/ScrollSnapContainer.jsx';

// UI Components
export { Button } from './ui/Button.jsx';
export { Card, CardImage, CardBody, CardTitle, CardDescription, CardFooter } from './ui/Card.jsx';
export { Icon } from './ui/Icon.jsx';
export { ThemeToggle } from './ui/ThemeToggle.jsx';
export { Accordion, FAQSection } from './ui/Accordion.jsx';

// Providers
export { ThemeProvider, useTheme } from './providers/ThemeProvider.jsx';

// Scroll Components
export { SmoothScrollProvider, useSmoothScroll } from './scroll/SmoothScrollProvider.jsx';

// Section Components
export { HeroSection } from './sections/HeroSection.jsx';
export { ServicesSection } from './sections/ServicesSection.jsx';
export { CTASection } from './sections/CTASection.jsx';
export { GuidePage } from './sections/GuidePage.jsx';

// Animation Components
export { FadeIn, FadeInStagger } from './animation/FadeIn.jsx';
export { ScrollAnimation } from './animation/ScrollAnimation.jsx';

// Form Components
export { ContactForm } from './forms/ContactForm.jsx';

// Tool Components
export { ApacheLogAnalyzer } from './tools/ApacheLogAnalyzer.jsx';
export { JSONFormatter } from './tools/JSONFormatter.jsx';
export { HtaccessGenerator } from './tools/HtaccessGenerator.jsx';
export { Base64Tool } from './tools/Base64Tool.jsx';
export { PasswordGenerator } from './tools/PasswordGenerator.jsx';
export { CronGenerator } from './tools/CronGenerator.jsx';
export { VimHelper } from './tools/VimHelper.jsx';
export { RegexTester } from './tools/RegexTester.jsx';
export { SSHKeyGuide } from './tools/SSHKeyGuide.jsx';
export { DataTransformer } from './tools/DataTransformer.jsx';
